import { InjectionToken, Provider } from '@angular/core';

export const permissionKeys = {
  dashboard: {
    LEADERBOARDS: 'leaderboards',
    MARKETING: 'marketing',
    BUG_REPORT: 'bugReport',
  },
  settings: {
    COUNTRY: 'country',
    SCRIPTS: 'scripts',
    PRIZE_ZONE: 'prizeZone',
    LEAGUE: 'league',
    GATEWAYS: 'gateways',
  },
  dff: {
    CONTEST: 'contest',
    DFF_GAME_FIXTURE: 'dffGameFixture',
    DFF_MATCH_USERS: 'dffMatchUsers',
    DFF_SEASON: 'dffSeason',
    GAME_FIXTURE: 'gameFixture',
    GAME_PRIZE: 'gamePrize',
    SIMULATE: 'simulate',
  },
  sff: {
    SFF_SEASON_LEAGUE: 'sffSeasonLeague',
    SFF_MD_PRIZE_ZONE: 'sffMdPrizeZone',
    SFF_LEAGUE_USER: 'sffLeagueUser',
    SFF_MD_USER_TEAM: 'sffMdUserTeam',
    SFF_MD_MATCHES: 'sffMdMatches',
    SFF_USER_TEAM: 'sffUserTeam',
    WONDER_LEAGUE: 'wonderLeague',
  },
  accounts: {
    RFT_BANK: 'rftBank',
    PAYMENT: 'payment',
    PAYOUT: 'payout',
    SFF_TRANSACTION: 'sffTransaction',
    DFF_TRANSACTION: 'dffTransaction',
  },
  users: {
    USER: 'user',
    ADMIN_ONBOARD: 'adminOnboard',
  },
  assets: {
    ASSETS: 'assets',
  },
  notification: {
    NOTIFICATION: 'notification',
  },
  subscription: {
    SFF_SUBSCRIPTION: 'sffSubscription',
    RFTC_PACK: 'rftcPack',
    LEAGUE_PACK: 'leaguePack',
    PAID_TRANSFER_PACKS: 'paidTransferPacks',
  },
  survey: {
    SURVEY: 'survey',
  },
  'refer-earn': {
    RFT_REFERRAL: 'rftReferral',
  },
} as const;
export interface IPermissionKeys {
  dashboard: {
    LEADERBOARDS: string;
    MARKETING: string;
    BUG_REPORT: string;
  };

  settings: {
    COUNTRY: string;
    SCRIPTS: string;
    PRIZE_ZONE: string;
    LEAGUE: string;
    GATEWAYS: string;
  };

  dff: {
    CONTEST: string;
    DFF_GAME_FIXTURE: string;
    DFF_MATCH_USERS: string;
    DFF_SEASON: string;
    GAME_FIXTURE: string;
    GAME_PRIZE: string;
    SIMULATE: string;
  };

  sff: {
    SFF_SEASON_LEAGUE: string;
    SFF_MD_PRIZE_ZONE: string;
    SFF_LEAGUE_USER: string;
    SFF_MD_USER_TEAM: string;
    SFF_MD_MATCHES: string;
    SFF_USER_TEAM: string;
    WONDER_LEAGUE: string;
  };

  accounts: {
    RFT_BANK: string;
    PAYMENT: string;
    PAYOUT: string;
    SFF_TRANSACTION: string;
    DFF_TRANSACTION: string;
  };

  users: {
    USER: string;
    ADMIN_ONBOARD: string;
  };

  assets: {
    ASSETS: string;
  };

  notification: {
    NOTIFICATION: string;
  };

  subscription: {
    SFF_SUBSCRIPTION: string;
    RFTC_PACK: string;
    LEAGUE_PACK: string;
    PAID_TRANSFER_PACKS: string;
  };

  survey: {
    SURVEY: string;
  };

  'refer-earn': {
    RFT_REFERRAL: string;
  };
}

export const PERMISSION_KEYS = new InjectionToken<IPermissionKeys>(
  'PERMISSION_KEYS'
);

export const permissionProvider: Provider = {
  provide: PERMISSION_KEYS,
  useValue: permissionKeys,
};

export enum PermissionActions {
  READ = 'read',
  WRITE = 'create',
  DEL = 'delete',
  EDIT = 'edit',
}

export const AllRoles = ['SUPER_ADMIN', 'COUNTRY_PARTNER', 'USER'];
